<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <div class="block">
                <button class="button is-success" @click="goback">返回</button>
            </div>
            <table class="table is-bordered">
                <thead>
                <tr>
                    <td>商品源Id</td>
                    <td>店铺名称</td>
                    <td>店铺地址</td>
                    <td>操作</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in list">
                    <td>{{item.sourceId}}</td>
                    <td>{{item.shopName}}</td>
                    <td>{{item.shopLink}}</td>
                    <td><button class="button is-danger" @click="deleteSouce(item,index)">删除</button></td>
                </tr>
                </tbody>
            </table>
        </article>
    </div>
</template>
<script type="text/babel">
    import {getTimeByDateStr} from 'UTILS/date'
    export default {
        data(){
            return {
                list:[],
                count:0,
                page:0,
                bloggerId:null,
            }
        },
        mounted(){
            this.bloggerId=this.$route.query.bloggerId;
            this.getTopicCategoryList();
        },
        methods: {
            goback(){
                this.$router.push({
                    name: 'cyzsIcon',
                    query: {
                        page: this.$route.query.page,
                        selectedBlogger: this.$route.query.selectedBlogger,
                        activeIndex: this.$route.query.activeIndex,
                        categoryId: this.$route.query.categoryId,
                    }
                })
            },
            getTopicCategoryList(){
                HttpRequest.get("/admin.php?method=blogger.getIconGoodsSourceList",{bloggerId:this.bloggerId}, true).then((response) => {
                    if(response.data){
                        this.list = response.data.list;
                    }else{
                        this.list = []
                    }
                });
            },
            deleteSouce(item,index){
                if(confirm("确定要删除吗")){
                    HttpRequest.post("/admin.php?method=blogger.removeBloggerGoodsSource",{sourceId:item.sourceId,bloggerId:this.bloggerId}, true).then((response) => {
                        if(response.data.success===1){
                            this.$message("删除成功");
                            this.list.splice(index,1)
                        }
                    });
                }

            }
        }
    }
</script>
<style lang="less">
    .category-img{
        height: 200px;
    }
</style>
